import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconRatingMedium(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <circle cx="12.5" cy="11.5" r="5.5" fill="currentColor" />
    </BaseIcon>
  );
}
